import { render, staticRenderFns } from "./MspForsageOrder.vue?vue&type=template&id=5093ab20&scoped=true"
import script from "./MspForsageOrder.vue?vue&type=script&lang=js"
export * from "./MspForsageOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5093ab20",
  null
  
)

export default component.exports